import { StyleSheet, Dimensions, Platform } from "react-native";
import ENV from "app/utils/ENV";

let WIDTH = Dimensions.get("window").width;
// WIDTH = 1000;
const HEIGHT = Dimensions.get("window").height;
// compared to designed on iphone xs max
// const screenRatio = Math.min(1.3, WIDTH / 414);
// export const screenRatio = Math.min(1.3, WIDTH / 1000);
export const screenRatio = Math.min(1.3, WIDTH / 400);
const verticalRatio = Math.min(1.3, HEIGHT / 896);
const aspectRatio = HEIGHT / WIDTH;
// iphone 5
const smallScreen = WIDTH <= 320;
const shortScreen = HEIGHT <= 568;
const DARK = ENV.DARK;
const phi = 1.61803399;
const inversePhi = 0.618033988;
const mobileIncrease = ENV.WEB ? 1 : 2.0;
const mediumMobileIncrease = ENV.WEB ? 1 : 1.5;
const largeFactor = 1.2;
const smallFactor = 0.9;

const RATIO7 = 0.377964473;
const RATIO7i = 2.645751311;
let CHILD_RATIO = RATIO7;
let PARENT_RATIO = RATIO7i;
CHILD_RATIO = 0.61;
PARENT_RATIO = 1.15;

const universalColors = {
  darkest: `#020202`,
  lightForeground: `#eeeeee`,
  darkForeground: "#7a6e69",
  lightest: `#f0f0f0`,
  transparent: `rgba(0,0,0, 0)`,
  inputBg: `rgba(50,50,50, 0.5)`,
  buttonBg: `rgba(200,200,200, 0.3)`,
  placeholder: "#666666",
  lightPlaceholder: "#aaaaaa",
};

const darkColors = {
  empty: universalColors.darkest,
  // empty: '#011420',
  // empty: '#00101d',
  fill: "#222222",
  // fill: '#202a30',
  foreground: universalColors.lightForeground,
  trim: "#444444",
  subtle: "#333333",
  active: "#4ad",
  activeHighlight: "#1fc",
  // heatmap: '#201',
  heatmap: "#222222",
  darkenBy: 0.6,
  darkenBy: 1,
};
const lightColors = {
  // empty: universalColors.lightest,
  // fill: '#dddddd',
  // foreground: '#444',
  // trim: '#999',
  // subtle: '#aaa',

  // empty: '#fff1ee',
  empty: "#f9ebdd",
  // empty: '#fff5f0',
  fill: "#f8ddd1",
  // fill: '#f8ede1',
  // fill: '#f5eade',
  // foreground: "#7a6e69",
  foreground: universalColors.darkForeground,
  inactive: "#af9f98",
  // trim: '#e8cdc1',
  trim: "#e3cabe",
  // subtle: '#aa9c95',
  subtle: "#e3cabe",

  active: "#c691e5",
  activeHighlight: "#e060ff",
  // heatmap: '#b9a',
  heatmap: "#ccc",
  darkenBy: 0.95,
  darkenBy: 1,
};
let allColors = ENV.DARK ? darkColors : lightColors;
// export const colors = allColors
export const colors = ENV.DARK
  ? { ...darkColors, ...universalColors }
  : { ...lightColors, ...universalColors };
allColors = { ...colors, ...universalColors };

export const getColors = () => {
  return ENV.DARK()
    ? { ...darkColors, ...universalColors }
    : { ...lightColors, ...universalColors };
};

// Re-theme the statically exported `colors` and `styleSheet` objects in
// place. 100+ files import these at module load, so they'd otherwise stay
// frozen on the scheme active at page load; mutating the exported objects
// lets every consumer pick up the new scheme on its next render (the
// StyleProvider calls this whenever the effective dark mode changes).
export const applyColorScheme = (dark) => {
  let scheme = dark
    ? { ...darkColors, ...universalColors }
    : { ...lightColors, ...universalColors };
  Object.keys(colors).forEach((key) => delete colors[key]);
  Object.assign(colors, scheme);
  styleSheet.input.color = colors.foreground;
  styleSheet.icon.color = colors.foreground;
  styleSheet.bullet.borderColor = colors.trim;
  styleSheet.hr.borderColor = colors.trim;
};

export let sizes = {
  tiny: 3,
  small: 5,
  base: 10,
  large: 20,
  giant: 40,
  extraGiant: 60,
  smallItemHeight: 15,
  default: 15,
  medium: 15,
  itemHeight: 30,
  smallBorderRadius: 5,
  borderRadius: 10,
  // borderRadius: 5,
  // bulletWidth: ,
  bulletWidth: 20 + 3 * 2, // sizes.large + (sizes.tiny*2)
  largeBulletWidth: (20 + 3 * 2) * largeFactor,
};
if (!ENV.WEB) {
  Object.keys(sizes).map((key, index) => {
    // sizes[key] *= 2;
  });
}

export const styleSheet = {
  input: {
    fontSize: sizes.default,
    minHeight: sizes.default,
    // backgroundColor: colors.inputBg,
    color: colors.foreground,
    // marginBottom: sizes.base,
    borderWidth: 0,
  },
  icon: {
    // fontSize: sizes.smallItemHeight,
    fontSize: sizes.itemHeight,
    // width: sizes.itemHeight,
    padding: sizes.base,
    color: colors.foreground,
    // marginHorizontal: sizes.small,
  },
  bullet: {
    width: sizes.large,
    height: sizes.large,
    lineHeight: sizes.large,
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    textAlignVertical: "center",
    fontSize: 12,
    borderWidth: 0.5,
    borderColor: colors.trim,
    borderRadius: sizes.large / 2,
    marginHorizontal: sizes.tiny,
    overflow: "hidden",
  },
  mobileLargeBullet: {
    width: sizes.large * mobileIncrease,
    height: sizes.large * mobileIncrease,
    lineHeight: sizes.large * mobileIncrease,
    fontSize: 12 * mobileIncrease,
    borderRadius: (sizes.large / 2) * mobileIncrease,
    marginHorizontal: sizes.tiny * mobileIncrease,
  },
  mobileMediumBullet: {
    width: sizes.large * mediumMobileIncrease,
    height: sizes.large * mediumMobileIncrease,
    lineHeight: sizes.large * mediumMobileIncrease,
    fontSize: 12 * mediumMobileIncrease,
    borderRadius: (sizes.large / 2) * mediumMobileIncrease,
    marginHorizontal: sizes.tiny * mediumMobileIncrease,
  },
  largeBullet: {
    width: sizes.large * largeFactor,
    height: sizes.large * largeFactor,
    lineHeight: sizes.large * largeFactor,
    fontSize: 12 * largeFactor,
    borderRadius: (sizes.large / 2) * largeFactor,
    marginHorizontal: sizes.tiny * largeFactor,
  },
  smallBullet: {
    width: sizes.large * smallFactor,
    height: sizes.large * smallFactor,
    lineHeight: sizes.large * smallFactor,
    fontSize: 12 * smallFactor,
    borderRadius: (sizes.large / 2) * smallFactor,
    marginHorizontal: sizes.tiny * smallFactor,
  },
  giantBullet: {
    width: sizes.large * largeFactor * 1.8,
    height: sizes.large * largeFactor * 1.8,
    lineHeight: sizes.large * largeFactor * 1.8,
    fontSize: 12 * largeFactor * 1.8,
    borderRadius: (sizes.large / 2) * largeFactor * 1.8,
    marginHorizontal: sizes.tiny * largeFactor * 1.8,
    marginHorizontal: 0,
  },
  hr: {
    width: "100%",
    height: 0,
    marginVertical: sizes.base,
    borderBottomWidth: 1,
    borderColor: colors.trim,
  },
};

const test = () => {
  return ENV.DARK;
};

export {
  DARK,
  WIDTH,
  HEIGHT,
  phi,
  inversePhi,
  mobileIncrease,
  mediumMobileIncrease,
  CHILD_RATIO,
  PARENT_RATIO,
  test,
};
